import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoIsItForSection() {
  const forWho = ['Empáticos y personas altamente sensibles (PAS).', 'Profesionales en salud, ventas, educación o entornos corporativos hostiles.', 'Personas que conviven con familiares difíciles o narcisistas.', "Cualquier persona que se sienta 'drenada' después de interacciones sociales."];
  const notForWho = ['Quienes buscan rituales mágicos que no requieren práctica personal.', 'Personas que no están dispuestas a dedicar 3 minutos a su higiene mental.', "Quienes prefieren seguir quejándose de la 'mala vibra' en lugar de tomar el control."];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-navy-950" data-id="element-213">
      <div className="max-w-5xl mx-auto" data-id="element-214">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-215">
          {/* Para ti si */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-navy-900 border border-green-900/30 rounded-xl p-8" data-id="element-216">
            <h3 className="text-2xl font-serif text-white mb-8 flex items-center gap-3" data-id="element-217">
              <span className="w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center" data-id="element-218">
                <Check className="w-5 h-5 text-green-400" data-id="element-219" />
              </span>
              Esto ES para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-220">
              {forWho.map((item, index) => <li key={index} className="flex gap-4 text-gray-300" data-id="element-221">
                  <Check className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" data-id="element-222" />
                  <span className="leading-relaxed" data-id="element-223">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti si */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-navy-900 border border-red-900/20 rounded-xl p-8 opacity-80" data-id="element-224">
            <h3 className="text-2xl font-serif text-gray-400 mb-8 flex items-center gap-3" data-id="element-225">
              <span className="w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-226">
                <X className="w-5 h-5 text-red-400/70" data-id="element-227" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-228">
              {notForWho.map((item, index) => <li key={index} className="flex gap-4 text-gray-400" data-id="element-229">
                  <X className="w-5 h-5 text-red-400/50 flex-shrink-0 mt-0.5" data-id="element-230" />
                  <span className="leading-relaxed" data-id="element-231">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}